// Analytics disabled for self-hosted Surfboard Diagrams
export const trackEvent = (
  _category: string,
  _action: string,
  _label?: string,
  _value?: number,
) => {
  // no-op
};
